import HttpService from "./http-service";
import News, {ThumbnailImage} from "@/entities/news";
import AsyncPaginatedRequest from "./async-paginated-request";
import { LazyAsyncIter } from "@/iterators";
import { pageMapperBuilder, Paginated } from "@/pagination";
import { AxiosResponse } from "axios";

export default class NewsService extends HttpService {
  public getAllNews(
    params: SearchNewsRequestParams
  ): AsyncIterator<Paginated<News>> {
    const asyncReq = new AsyncPaginatedRequest<NewsDTO>(
      "get",
      "news",
      params,
      undefined,
      this.httpClient
    )[Symbol.asyncIterator]();
    return new LazyAsyncIter(asyncReq).map(pageMapperBuilder(newsFromDTO));
  }

  public async getPublicNews(page:number ):Promise<Paginated<News[]>> {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const { data } = await this.httpClient.get("news?page=" + page);
    return data;
  }

  public async getNews(newId: number): Promise<News> {
    const { data } = await this.httpClient.get<NewsDTO>(`/news/${newId}`);
    return newsFromDTO(data);
  }

  public async insertNews(news: Omit<NewsDTO, "id">): Promise<void> {
    const config = {
      headers: { "content-type": "multipart/form-data" },
    };
    const formData = new FormData()
    formData.append('title',news.title);
    formData.append('text_intro',news.text_intro);
    formData.append('text_full',news.text_full);
    formData.append('status',news.status ? '2' : '1');
    formData.append('slug',news.slug);
    formData.append('images',JSON.stringify(news.images));
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    formData.append('thumbnail',news.thumbnail!);

    const { data } = await this.httpClient.post(`/news`, formData,config);
    return data;
  }

  public async updateNews(news: News): Promise<AxiosResponse<unknown>> {
    const config = {
      headers: { "content-type": "multipart/form-data" },
    };
    delete news.slug;
    const formData = new FormData();
    formData.append('title',news.title);
    formData.append('text_intro',news.text_intro);
    formData.append('text_full',news.text_full);
    formData.append('status',news.status ? '2' : '1');
    formData.append("_method", "PUT");
    formData.append('images',JSON.stringify(news.images));
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if(news.thumbnail != null){
    formData.append('thumbnail',news.thumbnail);

    }
    return await this.httpClient.post(`/news/${news.id}`, formData, config);
  }

  public async deleteNews(newId: number): Promise<AxiosResponse<unknown>> {
    return await this.httpClient.delete(`/news/${newId}`);
  }
}

export interface NewsDTO {
  id: number;
  title: string;
  slug: string;
  text_intro: string;
  text_full: string;
  status: number;
  images: Array<number>;
  thumbnail?: File;
  news_thumbnail_image: ThumbnailImage
  created_at:string
}

export function newsFromDTO(dto: NewsDTO): News {
  return new News({
    id: dto.id,
    title: dto.title,
    slug: dto.slug,
    text_intro: dto.text_intro,
    text_full: dto.text_full,
    status: dto.status,
    images: dto.images,
    thumbnail: dto.thumbnail,
    news_thumbnail_image: dto.news_thumbnail_image,
    created_at: dto.created_at
  });
}

export interface SearchNewsRequestParams {
  title?: string;
  status?: string;
}
